import type { RouteObject } from "react-router";
import { SaleList } from "./SaleList";

export const saleRoute: RouteObject = {
  path: "sale",
  element: <SaleList />,
};
